import {
    ON_START_IMPORT_ITESCO,ON_IMPORT_ITESCO,ON_ERROR_IMPORT_ITESCO,
}
from "../constants/ActionTypes";
import { translate } from "../util/intlHelper";

const INIT_STATE = {
    message:"",
    isloading:false,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case ON_START_IMPORT_ITESCO:{
            console.log("ON_START_IMPORT_ITESCO",action)
            return {
              ...state,
              message:"",
              isLoading:true
            }
          }
        case ON_IMPORT_ITESCO:{
            console.log("ON_IMPORT_ITESCO",action)
            return {
              ...state,
              message:translate("Action.Import"),
              isLoading:false
            }
          }
        case ON_ERROR_IMPORT_ITESCO:{
            console.log("ON_ERROR_IMPORT_ITESCO",action)
            return {
              ...state,
              message:translate("Error.Import"),
              isLoading:false
            }
          }
        default: return state;   
    }
}